import { Chart } from "./Chart";
import { Controls } from "./Controls";
import { useState } from "react";
import "./ScoreBreakdown.scss";
import { Helmet } from "react-helmet-async";
import { useRoute } from "wouter";
import { Meta } from "./Meta";

const baseFilters = {
	grants: { value: true, fullText: "Grants", label: "Grants" },
	publications: {
		value: true,
		fullText: "Academic Publications",
		label: "Publications",
	},
	patents: { value: true, fullText: "Patents", label: "Patents" },
	investments: {
		value: true,
		fullText: "Investments",
		label: "Investments",
	},
};
const sortOptions = [
	{ label: "Alphabetical", key: "alphabetical" },
	// { label: "Category", key: "category" },
	{ label: "Grants Score (High - Low)", key: "grants" },
	{ label: "Publications Score (High - Low)", key: "publications" },
	{ label: "Patents Score (High - Low)", key: "patents" },
	{ label: "Investments Score (High - Low)", key: "investments" },
];
export function ScoreBreakdown() {
	const [filters, setFilters] = useState(baseFilters);
	const [sort, setSort] = useState(sortOptions[0]);
	const [controlsHeight, setControlsHeight] = useState(0);

	return (
		<div className={"score-breakdown"}>
			<Helmet>
				<title>
					Score Breakdown | L'Atelier Virtual Economy Technology Radar
				</title>
			</Helmet>
			<Controls
				updateFilters={setFilters}
				filters={filters}
				updateSort={setSort}
				sort={sort}
				sortOptions={sortOptions}
				setControlsHeight={setControlsHeight}
			/>
			<Chart
				filters={filters}
				sort={sort.key}
				controlsHeight={controlsHeight}
			/>
			<Meta />
		</div>
	);
}
